import CryptoJS from 'crypto-js'

export default {
    criptografarMD5
}

export function criptografarMD5(texto) {
    var hash = CryptoJS.MD5(texto);
    return hash.toString(CryptoJS.enc.Base64);
}